var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebmasters(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2677",
    "data-name": "Group 2677",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.397,
    height: 22.397,
    viewBox: "0 0 22.397 22.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1447",
    "data-name": "Rectangle 1447",
    width: 22.397,
    height: 22.397,
    fill: "#22c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2676",
    "data-name": "Group 2676",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8235",
    "data-name": "Path 8235",
    d: "M11.2,0A11.2,11.2,0,1,0,22.4,11.2,11.2,11.2,0,0,0,11.2,0M8.142,13.868l-.855.855L3.761,11.2,7.287,7.672l.855.855L5.471,11.2Zm2.119,1.923L9.1,15.437,11.818,6.6l1.156.355Zm4.85-1.069-.855-.855L16.926,11.2,14.255,8.527l.855-.855L18.636,11.2Z",
    transform: "translate(0 0.001)",
    fill: "#22c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebmasters);
export default __webpack_public_path__ + "static/media/webmasters.b2265a58d0d81db736670df7ce8d416d.svg";
export { ForwardRef as ReactComponent };